import { createFeatureSelector, createSelector } from "@ngrx/store";
import { TariffsState } from "./tariff.models";
import { SavingStatus } from "../../../shared/models/list.page.model";

export const tariffsState = createFeatureSelector<TariffsState>('tariffs');

export const selectLoading = createSelector(
    tariffsState,
    (state) => state.loading
)

export const selectTariffs = createSelector(
    tariffsState,
    (state) => state.tariffs
)

export const selectTariffsPagination = createSelector(
    tariffsState,
    (state) => state.tariffsPagination
)

export const selectTariffTotalCount = createSelector(
    tariffsState,
    (state) => state.tariffsPage?.totalCount ?? 0
)

export const selectTariffsSavingStatus = createSelector(
    tariffsState,
    (state) => state.tariffsSaveInProgress ?? SavingStatus.NotStarted
)